export default "https://assets.egbcdn.net/assets/packs/_/images/app/ios/ios-ru-3-8cf10d92bc643b628192d60a6a7fb4ae.png";